// extracted by mini-css-extract-plugin
module.exports = {"heroVideo":"Hero_heroVideo__lDKQZ","heroVideoOverlay":"Hero_heroVideoOverlay__qC912","heroVideoTitle":"Hero_heroVideoTitle__3iFsN"};